module.exports = __webpack_public_path__ + "b43736397ee2e788d1144e7ce341f340.svg";